<template>
<div class="app">
<test/>
<router-view/>
<Footer/>
</div>
</template>

<script>
import test from './components/header.vue'
import Footer from './components/footer.vue'
export default {
  name: 'App',
  components: {
    test,
    Footer
  }
}
</script>

<style>
.app {
	position: absolute;
	left:0;
	top:0;
  /* height: 100%; */
  width: 100%;
}
</style>
